import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../../app-config.module';

@Injectable()
export class LatLongToPostcodeService {
  constructor(private http: HttpClient, @Inject(APP_CONFIG) public config: AppConfig) {}

  /**
   * gets postcode based on latitude and longitude positions
   *
   * @param pos
   */
  public getPostcodeByLocation(pos: { lat: number; lon: number }): Observable<any> {
    const httpParams = new HttpParams().append('lon', `${pos.lon}`).append('lat', `${pos.lat}`);
    return this.http.get(this.config.postcodeSearchUrl, { observe: 'body', params: httpParams });
  }
}
